var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"overlay"},[_c('b-spinner',{staticClass:"uil-ring-css",attrs:{"variant":"primary","label":"Spinning"}})],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }